import { render, staticRenderFns } from "./CustomerImportIlustra.vue?vue&type=template&id=fde31226&"
import script from "./CustomerImportIlustra.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportIlustra.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports